import { render, staticRenderFns } from "./DetailsContract.vue?vue&type=template&id=84ba0822&scoped=true"
import script from "./DetailsContract.vue?vue&type=script&lang=js"
export * from "./DetailsContract.vue?vue&type=script&lang=js"
import style0 from "./DetailsContract.vue?vue&type=style&index=0&id=84ba0822&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ba0822",
  null
  
)

export default component.exports